import './bootstrap';
import '../css/app.css';

import { createApp } from 'vue'; // Import Vue 3's createApp function
import YoutubeTranscript from './Components/YoutubeTranscript.vue';
import YoutubeDescription from './Components/YoutubeDescription.vue';

const app = createApp({
    components: {
        YoutubeTranscript,
        YoutubeDescription
    },
});
app.mount('#app');
